export const TANDLÄKARE = "1";
export const TANDHYGIENIST = "2";
